// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fixed-height[data-v-0608085e]{height:36px}.fixed-height.size--x-small[data-v-0608085e]{height:20px}.fixed-height.size--small[data-v-0608085e]{height:28px}.fixed-height.size--large[data-v-0608085e]{height:44px}.fixed-height.size--x-large[data-v-0608085e]{height:52px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
